import * as React from 'react'
import SectionComponent from "./section-component"
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from "../../action-creators"
import { ReducerState, MappedActionsProps } from '../../reducer';
import { range } from 'lodash'

class Section extends React.Component<InjectedProps, State> {
	private readonly years: number[]

	constructor(props: Readonly<InjectedProps>) {
		super(props)
		const end   = (new Date()).getFullYear()
		const start = end - 6;
		this.years  = range(start, end)
		// this.state = {
		// 	loading: true,
		// }
	}

	state: State = { loading: true };

	componentDidUpdate(prevProps: InjectedProps) {
		if (prevProps.operation !== this.props.operation) {
			this.setState({ loading: true });

			const timerID = setTimeout(() => {
				this.setState({ loading: false });

				return clearTimeout(timerID);
			}, 100);
		}
	}

	componentWillReceiveProps(nextProps: InjectedProps) {
		if (nextProps.currentLocalAuthority)
			this.setState({ loading: false });
	}

	componentWillMount() {
		this.props.actions.setPageTitle(this.props.operation ? 'Fonctionnement' : 'Investissement');

		if (this.props.currentLocalAuthority)
			this.setState({ loading: false });
	}

	render() {
		return (
			<SectionComponent
			loading={this.state.loading}
			operation={this.props.operation}
			years={this.years}
			/>
		)
	}
}

const mapStateToProps = (state: ReducerState) => state
function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Section);

interface State {
	loading: boolean
}

interface SectionProps {
	operation: boolean
	showExport: boolean
}

type InjectedProps = MappedActionsProps &
SectionProps &
ReducerState


// WEBPACK FOOTER //
// ./src/component/section/index.tsx